import { Box, IconButton, Tooltip, Typography ,Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useState } from "react";
import ChatItem from "./ChatItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
const GroupedChatsFolder = ({
  group,
  activeSessionId,
  onSelectItem,
  handleMenuClick,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const groupName = group.name || group.title || "Untitled Group";
  const chats = group.messages || [];
  const shouldShowGroupTooltip = groupName.length > 29;

  return (
    <Box className="grouped-folder-container" sx={{ position: "relative" }}>
      <Tooltip
        title={groupName}
        placement="right"
        enterDelay={600}
        disableHoverListener={!shouldShowGroupTooltip}
        slotProps={{
          tooltip: {
            className: "chat-tooltip",
          },
        }}
      >
        <Box
          className="grouped-folder-header"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <Typography className="group-name">
            <span className="group-name-text">{groupName}</span>
            <IconButton
              size="small"
              sx={{
                padding: 0,
                width: 20,
                height: 20,
                color: "#555E6D",
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
              onClick={(e) => {
                e.stopPropagation();
                setIsExpanded((prev) => !prev);
              }}
            >
              {isExpanded ? (
                <ExpandLessIcon sx={{ fontSize: 16 }} />
              ) : (
                <ExpandMoreIcon sx={{ fontSize: 16 }} />
              )}
            </IconButton>
          </Typography>

          <Box className="folder-actions">
            <IconButton
              size="small"
              sx={{
                padding: 0,
                width: 20,
                height: 20,
                color: "#555E6D",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleMenuClick(e, group, "folder");
              }}
            >
              <MoreVertIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Box>
        </Box>
      </Tooltip>
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <Box className="grouped-chats-list" sx={{ pl: 2}}>
          {chats.length === 0 ? (
            <Typography
              sx={{
                fontSize: "12px",
                color: "#9BA8B5",
                fontStyle: "italic",
                padding: "8px 12px",
              }}
            >
              No chats in this group
            </Typography>
          ) : (
            chats.map((chat) => (
              <ChatItem
                key={chat.session_id || chat.id}
                item={chat}
                activeSessionId={activeSessionId}
                onSelectItem={onSelectItem}
                handleMenuClick={handleMenuClick}
                groupId={group.id}
              />
            ))
          )}
        </Box>
      </Collapse>
    </Box>
  );
};

export default GroupedChatsFolder;
